import React, { useState } from 'react'; // <--- Import useState
import './Home.css';
import { Link } from 'react-router-dom'; // <--- Import Link
import backgroundImage from '../assets/Untitleddesign.png';
import inspirationImage from '../assets/Late-Umashankar-Tiwari-768x795.png'
import schoolImage from '../assets/school-1.jpg'; // <-- Add this import for the school image
import workshopImage from '../assets/indutai-workshop.jpg';

// --- Lightbox Imports ---
import Lightbox from 'react-18-image-lightbox'; // <--- Import Lightbox component
import 'react-18-image-lightbox/style.css'; // <--- Import Lightbox CSS (Crucial!)


// --- Dynamic Image Import for VSS Activities (keep this as is) ---
const importAll = (r) => {
  return r.keys().map(r);
};
const activityPhotos = importAll(require.context('../assets/vss_activities/', false, /\.jpe?g$|\.png$/));

// You can console.log(activityPhotos) here to see the array of image paths
// console.log(activityPhotos);

function Home() {
  // --- State for Lightbox ---
  const [photoIndex, setPhotoIndex] = useState(0); // Index of the currently viewed photo
  const [isOpen, setIsOpen] = useState(false);     // Whether the lightbox is open

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className='Home'>
      <div className="hero">
        <div
          className="parallaxBackground"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        ></div>
        <div className="heroContent">
          <h1>VISHWAMBHAR SHIKSHAN SANSTHA, NAGPUR.</h1>
        </div>
      </div>

      <section className="about">
        <p>
          Vishwambhar Shikshan Sanstha, Nagpur, founded in
          the year 2006, aims at the Intellectual,
          Educational, Social Development and Vocational
          Rehabilitation of Intellectually Disabled Girls.

          It was founded in the loving memory, and thus named
          after, Late Lilatai Deshmukh Teaching Training and
          Rehabilitation Centre for Intellectually Disabled
          Girls (Special School) & Smt. Indutai Dhoble
          Workshop & Rehabilitation Centre for Intellectually
          Disabled Girls.

          The institute aims at the overall development of
          its students.
          <br/><br/>
          Ranging from educating its students to build
          personal, social & functional academic skills,
          the final objective is to rehabilitate its students
          into vocational setups, and deem them independent.

          VSS has a special concern towards “Woman”, a
          daughter, sister, wife and mother, but above all,
          she’s a “Woman”.  We aim to empower women in a
          male-dominated society by providing quality
          education, competency-based training, temporary/
          permanent rehabilitation and shelter.
        </p>
        <div className="establishedYear">
          <strong>2006</strong>
          <span>Established Year</span>
        </div>
        <button className="readMoreButton"><a href='/about'>Read More</a></button>
      </section>

      <section className="specialSchemes">
        <div className="container">
          <h2 className="specialSchemesHeading">The institution has started special schemes for Mentally Challenged Girls.</h2>
          <div className="cardContainer">
            <div className="card">
              <h3 className="cardTitle">Day Care Centre</h3>
              <p className="cardDescription">For the mentally challenged girls</p>
            </div>
            <div className="card">
              <h3 className="cardTitle">Honoring Persons</h3>
              <p className="cardDescription">Working for the handicapped/challenged fields</p>
            </div>
            <div className="card">
              <h3 className="cardTitle">Help Line</h3>
              <p className="cardDescription">For physically handicapped boys.</p>
            </div>
            <div className="card">
              <h3 className="cardTitle">Interviews</h3>
              <p className="cardDescription">On All India Radio.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- NEW HELP HER SECTION --- */}
      <section className="helpHerSection">
        <div className="container">
          <h2 className="helpHerHeading">Help Her</h2>
          <p className="helpHerDescription">
            Providing Education, Empowerment, and Shelter for Mentally Challenged Girls and Women.
          </p>
          <div className="helpHerButtons">
            {/* You'll link this to your actual donate page */}
            <button className="helpHerDonateButton"><a href='/donate'>Donate Now</a></button>
            {/* Replace YOUR_WHATSAPP_NUMBER with your actual WhatsApp number, including country code (e.g., 919876543210 for India) */}
            <a href="https://wa.me/919503487006" target="_blank" rel="noopener noreferrer" className="helpHerWhatsAppButton">WhatsApp Us</a>
          </div>
        </div>
      </section>

      {/* --- NEW INSPIRATION SECTION --- */}
      <section className="inspirationSection">
        <div className="container inspirationContainer"> {/* Added a specific container class for this section */}
          <img src={inspirationImage} alt="Late Umashankar Tiwari" className="inspirationImage" />
          <div className="inspirationText">
            <h2 className="inspirationHeading">Our Inspiration Is <br/>Late Umashankar Tiwari</h2>
            <p className="inspirationMission">
              Our mission is to provide significant growth for the welfare and rehabilitation of intellectually challenged youngsters to transform them into better citizens and productive members of our Society. Safeguarding this welfare is the mutual responsibility of a progressive and democratic society in which these Special Girls have a right to be an integral part.
            </p>
          </div>
        </div>
      </section>
      {/* --- END NEW INSPIRATION SECTION --- */}

      {/* --- WHAT WE DO SECTION (With Links) --- */}
      <section className="whatWeDoSection">
        <div className="container">
          <h2 className="whatWeDoHeading">What We Do</h2>

          <div className="programCardsContainer">

            {/* Program 1: School Card - NOW CLICKABLE */}
            <Link to="/special-school" className="programCardLink"> {/* <--- Link wrapper */}
              <div className="programCard">
                <img src={schoolImage} alt="Smt. Lilatai Deshmukh Residential Special School" className="programImage" />
                <div className="programContent">
                  <h3 className="programTitle">Smt. Lilatai Deshmukh Residential Special School for Education, Training & Rehabilitation For Mentally Retired Girls</h3>
                  {/* Optional: Add a short description or paragraph here if you have more text */}
                </div>
              </div>
            </Link>

            {/* Program 2: Workshop Card - NOW CLICKABLE */}
            <Link to="/workshop" className="programCardLink"> {/* <--- Link wrapper */}
              <div className="programCard">
                <img src={workshopImage} alt="Indutai Dhoble Workshop & Rehabilitation Centre" className="programImage" />
                <div className="programContent">
                  <h3 className="programTitle">Indutai Dhoble Workshop & Rehabilitation Centre For Mentally Challenge Girl</h3>
                  {/* Optional: Add a short description or paragraph here if you have more text */}
                </div>
              </div>
            </Link>

          </div> {/* End programCardsContainer */}

        </div>
      </section>
      {/* --- END WHAT WE DO SECTION --- */}

      {/* --- VSS ACTIVITY SECTION (With Lightbox Integration) --- */}
      <section className="vssActivitySection">
        <div className="container">
          <h2 className="vssActivityHeading">VSS Activity</h2>
          <div className="activityGallery">
            {activityPhotos.map((photoUrl, index) => (
              <div
                key={index}
                className="activityPhotoWrapper"
                onClick={() => openLightbox(index)} // <--- Add onClick handler here
                style={{ cursor: 'pointer' }} // <--- Add cursor pointer for visual cue
              >
                <img src={photoUrl} alt={`VSS Activity ${index + 1}`} className="activityPhoto" loading="lazy" />
              </div>
            ))}
          </div>

          {/* --- Lightbox Component --- */}
          {isOpen && (
            <Lightbox
              mainSrc={activityPhotos[photoIndex]} // The current photo to display
              nextSrc={activityPhotos[(photoIndex + 1) % activityPhotos.length]} // Next photo (loops back to start)
              prevSrc={activityPhotos[(photoIndex + activityPhotos.length - 1) % activityPhotos.length]} // Previous photo (loops back to end)
              onCloseRequest={() => setIsOpen(false)} // Callback when lightbox is closed
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + activityPhotos.length - 1) % activityPhotos.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % activityPhotos.length)
              }
              // Optional: Add a title/caption below the image
              imageTitle={`Photo ${photoIndex + 1} of ${activityPhotos.length}`}
              // Optional: Add any custom styling for buttons or overlays if needed
              // enableZoom={false} // Disable zoom if you don't want it
            />
          )}
        </div>
      </section>
      {/* --- END VSS ACTIVITY SECTION --- */}

    </div>
  );
}

export default Home;